import { render } from "./ChangeTypes.vue?vue&type=template&id=0d0f32c7&ts=true"
import script from "./ChangeTypes.vue?vue&type=script&lang=ts"
export * from "./ChangeTypes.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__